export default "__VITE_ASSET__B$odvMqo__"